import React from 'react';
import VehicleHub from './VehicleHub';

const config = {
  // Blog guides about this model, rendered as the hub's spoke links. Posts
  // whose own target is this hub's query ("buy/used <model> taxi Delhi")
  // are deliberately left out — linking them would build a competitor.
  guides: [
    'ertiga-cng-running-cost-delhi',
    'ertiga-vs-innova-7-seater-taxi-comparison',
    'best-7-seater-taxi-under-10-lakh-delhi',
  ],
  slug: '/ertiga-commercial-taxi-delhi',
  brand: 'Maruti Suzuki',
  model: 'Ertiga',
  displayName: 'Maruti Suzuki Ertiga',
  breadcrumbLabel: 'Maruti Ertiga Commercial Taxi — Delhi',
  seoTitle: 'Maruti Suzuki Ertiga Commercial Taxi for Sale — Delhi NCR',
  seoDescription: 'Buy used Maruti Suzuki Ertiga commercial taxis in Delhi NCR. 7-seater CNG MPV with commercial RC — verified BST listings and transparent pricing.',
  keywords: 'Maruti Ertiga commercial taxi Delhi, used Ertiga CNG taxi Delhi, Ertiga yellow plate Delhi, Ertiga taxi price Delhi 2026, buy Ertiga taxi Delhi NCR, 7 seater CNG taxi Delhi, Ertiga resale value commercial, Ertiga fleet taxi Delhi',
  h1: 'Maruti Suzuki Ertiga Commercial Taxi for Sale in Delhi NCR',
  answerCapsule: 'Used Maruti Suzuki Ertiga commercial (CNG/Petrol) taxis in Delhi NCR are priced between ₹4 lakh and ₹10 lakh depending on year and mileage. The Ertiga is the most affordable 7-seater MPV for commercial taxi operations in Delhi — offering more seating than a sedan at a fraction of an Innova\'s cost. Buy Sell Taxi lists verified Ertiga units with commercial RC for fleet operators and independent drivers.',
  specs: [
    ['Category', 'MPV / 7-Seater Commercial Taxi'],
    ['Engine', '1.5L Petrol (CNG Kit) / 1.5L Diesel (older models)'],
    ['Fuel Type', 'CNG / Petrol / Diesel'],
    ['Seating', '7 Seats'],
    ['Transmission', 'Manual (AMT available)'],
    ['CNG Mileage', '20–26 km/kg'],
    ['Boot Space', '209 litres (3rd row up)'],
    ['Commercial Permit', 'City taxi permit / All India Tourist Permit'],
    ['Typical Use', 'Family taxi, corporate shuttle, mini van hire, airport transfers'],
  ],
  priceData: [
    ['2017', '2,50,000 km', '₹4L – ₹5.5L',   'Good'],
    ['2018', '2,00,000 km', '₹5L – ₹6.5L',   'Very Good'],
    ['2019', '1,40,000 km', '₹6L – ₹7.5L',   'Excellent'],
    ['2020', '1,00,000 km', '₹7L – ₹8.5L',   'Excellent'],
    ['2021', '60,000 km',   '₹8.5L – ₹10.5L', 'Like New'],
  ],
  whyPoints: [
    '7 seats at a cost significantly lower than an Innova Crysta — ideal for budget-conscious fleet operators.',
    'CNG variants offer low running costs for city cab operations where fuel bills are the largest expense.',
    'Maruti\'s wide parts availability and affordable service costs keep total cost of ownership (TCO) low.',
    'Compact enough for city driving while still offering 7-seat capacity — versatile for both city and outstation routes.',
    'Strong buyer demand means quick liquidity — Ertiga commercial taxis sell faster than most competing MPVs.',
  ],
  faqs: [
    {
      q: 'What is the commercial financing interest rate for a used Ertiga taxi in Delhi?',
      a: 'Commercial vehicle loans for used Maruti Ertiga taxis in Delhi typically range from 10–14% per annum from banks like HDFC, Axis, and SBI. NBFCs like Mahindra Finance and Shriram Finance may offer slightly higher rates (13–17%) but are more flexible with documentation requirements for first-time commercial buyers. Loan tenures are typically 2–4 years for used vehicles.',
    },
    {
      q: 'Is a Maruti Ertiga CNG better than an Innova Crysta for commercial taxi in Delhi?',
      a: 'For city cab operations focused on cost efficiency, a Maruti Ertiga CNG is far more economical per km than an Innova Crysta diesel. The Ertiga has lower purchase price, lower running cost, and lower maintenance expense. However, the Innova Crysta commands significantly higher fares for outstation and premium services. The right choice depends on your route and fare structure.',
    },
    {
      q: 'What is the resale value of a commercial Maruti Ertiga in Delhi in 2026?',
      a: 'A 2019 Maruti Suzuki Ertiga with commercial yellow plate and around 1.4 lakh km sells for ₹6–7.5 lakh in Delhi in 2026. CNG-fitted variants hold their value better than petrol-only units. Service history from an authorized Maruti centre adds ₹30,000–₹50,000 in premium over unserviced vehicles.',
    },
    {
      q: 'Can I register an Ertiga with All India Tourist Permit (AITP) for outstation taxi in Delhi?',
      a: 'Yes. A Maruti Ertiga with commercial yellow plate RC can obtain an All India Tourist Permit from the Delhi transport department, enabling inter-state taxi operations across India. This is particularly common for Ertiga operators running routes from Delhi to Agra, Jaipur, Manali, and other tourist destinations.',
    },
    {
      q: 'What is the seating capacity of a commercial Ertiga and can extra passengers pay extra?',
      a: 'The Maruti Ertiga has a legal seating capacity of 7 including the driver (6 passengers). Commercial operators cannot legally carry more than the registered seating capacity. Metered or app-cab fares apply per the permit zone. For larger groups, operators often recommend upgrading to an Innova Crysta (7 pax) or Tempo Traveller.',
    },
  ],
};

const ErtigaHub = () => <VehicleHub config={config} />;

export default ErtigaHub;
